import { PatentFoldersService } from '@/modules/patent-folders-module/patent-folders-service.interface';
import { injectService } from '@/inversify.config';
import { ref } from 'vue';
export function useFindPatentFolders(patentId) {
    const folders = ref([]);
    const service = injectService(PatentFoldersService);
    const isLoading = ref(false);
    const isError = ref();
    function findPatentFolders() {
        isLoading.value = true;
        service.findFoldersByPatentId(patentId)
            .then((response) => {
            folders.value = response.map((folder) => {
                return {
                    ...folder,
                    title: [
                        folder.spaceName,
                        folder.isRoot ? '/' : '/../',
                        folder.folderName,
                    ].join(' '),
                };
            });
        })
            .catch((error) => {
            isError.value = error;
            return [];
        })
            .finally(() => {
            isLoading.value = false;
        });
    }
    return {
        folders,
        isLoading,
        isError,
        findPatentFolders,
    };
}
